import client from '@/api/client';
import { gql } from '@apollo/client';
import { IB2bCompany } from '@/interfaces/base/interfaces';

const addB2BCompany = (companyData: IB2bCompany) => client
  .mutate({
    mutation: gql`
      mutation addB2BCompany($companyData: B2BCompanyInput) {
          addB2BCompany(companyData: $companyData) {
              id
          }
      }
  `,
    variables: {
      companyData,
    },
  });

const inviteB2BToCompany = (b2bCompanyId: number) => client
  .mutate({
    mutation: gql`
      mutation inviteB2BToCompany(
          $b2bCompanyId: Int,
      ) {
          inviteB2BToCompany(
              b2bCompanyId: $b2bCompanyId,
          ) {
              status
          }
      }
  `,
    variables: {
      b2bCompanyId,
    },
  });

const getB2BCompanies = () => client
  .query({
    query: gql`
      query {
          getB2BCompanies {
              contactPerson
              email
              id
              title
              phone
          }
      }
  `,
  });

export default {
  addB2BCompany,
  getB2BCompanies,
  inviteB2BToCompany,
};
